import { AppBar, Box, List, Tab, Tabs } from '@mui/material';
import { FC, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Loader, Page, PageTitleWithBack } from '../../../../../components';
import {
  getNeighborhoodSeriesExclusionOptions,
  getNeighborhoodSeriesSelectedExclusionOptions
} from '../../../../../fetch';
import { IExclusions, ISelectedExclusions } from '../../../../../models';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ExcludedOptionList } from './excluded-option-list';

export enum Exclude_Options_Tabs {
  Model_Specific = 'Model Specific',
  Universal = 'Universal'
}

export const ExcludedOptionsPage: FC = () => {
  const classes = useStyles();
  const { neighborhoodId, selectedSeriesId }: { neighborhoodId: string; selectedSeriesId: string } =
    useParams();

  const { isLoading: isLoadingSeriesExclusionOptions, data: neighborhoodsSeriesExclusionOptions } =
    useQuery<IExclusions, Error>(
      ['neighborhoodsSeriesExcludedOptions'],
      () => getNeighborhoodSeriesExclusionOptions(),
      {
        onSuccess: data => {},
        notifyOnChangeProps: 'tracked'
      }
    );

  const {
    data: neighborhoodsSeriesSelectedExclusionOptions,
    refetch: refetchNeighborhoodsSeriesSelectedExclusionOptions,
    isRefetching: isRefetchingNeighborhoodsSeriesSelectedExclusionOptions
  } = useQuery<ISelectedExclusions, Error>(
    ['neighborhoodSeriesSelectedExclusionOptions'],
    () => getNeighborhoodSeriesSelectedExclusionOptions(neighborhoodId, selectedSeriesId),
    {
      onSuccess: data => {},
      notifyOnChangeProps: 'tracked'
    }
  );
  const [selectedTab, setSelectedTab] = useState(Exclude_Options_Tabs.Model_Specific);

  return (
    <Page title="Options - Excluded Options">
      <PageTitleWithBack
        title="Excluded Options"
        backText={'Neighborhood Options'}
        backUrl={`/development/neighborhoods/${neighborhoodId}/options/${selectedSeriesId}`}
        subTitle={'Please indicate whether an option is excluded from this Series'}
      />
      {(isLoadingSeriesExclusionOptions ||
        isRefetchingNeighborhoodsSeriesSelectedExclusionOptions) && (
        <Loader type="fullscreen" position="centered" />
      )}
      {!isLoadingSeriesExclusionOptions && (
        <>
          <Box
            margin={{
              sm: '0 0 0 1rem'
            }}
          >
            <AppBar position="static" color="default" component="div" className={classes.tabBar}>
              <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(_, value) => {
                  setSelectedTab(value);
                }}
                variant="scrollable"
              >
                {Object.values(Exclude_Options_Tabs).map(tab => {
                  return (
                    <Tab value={tab} key={tab} id={`${tab}`} aria-controls={`${tab}`} label={tab} />
                  );
                })}
              </Tabs>
            </AppBar>
            {selectedTab === Exclude_Options_Tabs.Model_Specific && (
              <List
                component="div"
                aria-labelledby="nested-list-subheader"
                className={classes.list}
              >
                {neighborhoodsSeriesSelectedExclusionOptions &&
                  neighborhoodsSeriesExclusionOptions.modelSpecificOptions.map(
                    modelSpecificOption => (
                      <ExcludedOptionList
                        key={`${modelSpecificOption.className} ${modelSpecificOption.optionSetId}`}
                        set={modelSpecificOption}
                        setSelections={neighborhoodsSeriesSelectedExclusionOptions.optionSetValues}
                        selections={
                          neighborhoodsSeriesSelectedExclusionOptions.individualOptionValues
                        }
                        refetch={refetchNeighborhoodsSeriesSelectedExclusionOptions}
                      />
                    )
                  )}
              </List>
            )}
            {selectedTab === Exclude_Options_Tabs.Universal && (
              <List
                component="div"
                aria-labelledby="nested-list-subheader"
                className={classes.list}
              >
                {neighborhoodsSeriesSelectedExclusionOptions &&
                  neighborhoodsSeriesExclusionOptions.universalOptions.map(universalOption => (
                    <ExcludedOptionList
                      key={`${universalOption.className} ${universalOption.optionSetId}`}
                      set={universalOption}
                      setSelections={neighborhoodsSeriesSelectedExclusionOptions.optionSetValues}
                      selections={neighborhoodsSeriesSelectedExclusionOptions.universalValues}
                      refetch={refetchNeighborhoodsSeriesSelectedExclusionOptions}
                    />
                  ))}
              </List>
            )}
          </Box>
        </>
      )}
    </Page>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  header: {
    marginTop: theme.spacing(1)
  },
  list: {
    overflow: 'auto',
    margin: theme.spacing(1, 0)
  },
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
